module.exports = __webpack_public_path__ + "media/mypage/images/icons/icon_logout-e577546770df497b37f8e96890ba805e.png";